import React, { useMemo, useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import ContextMenu, { Position } from 'devextreme-react/context-menu';
import List from 'devextreme-react/list';
import './UserPanel.scss';
import type { UserPanelProps } from '../../types';
import { useAccount, useMsal } from '@azure/msal-react';
import { b2cPolicies } from '../../authConfig';

export default function UserPanel({ menuMode }: UserPanelProps) {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  //console.log(accounts);

  function navigateToProfile() {
    const editProfileRequest = {
      scopes: ["openid", "profile"],
      authority: b2cPolicies.authorities.editProfile.authority,
  };

    instance.loginPopup(editProfileRequest).catch((error) => {
      console.error("Error during profile edit flow:", error);
  });
  }

  function logOut() {
    instance.logoutPopup({
      postLogoutRedirectUri: "/",
      mainWindowRedirectUri: "/"
    }).catch((e: Error) => {
      console.error(e.message);
    });
  }

  const menuItems = useMemo(() => ([
    // {
    //   text: 'Profile',
    //   icon: 'user',
    //   onClick: navigateToProfile
    // },
    {
      text: 'Logout',
      icon: 'runner',
      onClick: logOut
    },    


//   {
//     template: () => <CustomLabel />,
//     disabled: true
//   },


  ]), []);

  return (
    <div className={'user-panel'}>
      <div className={'user-info'}>
        <div className={'image-container'}>
          <div
            style={{
              background: `url(/silhouette.png) no-repeat #fff`,
              backgroundSize: 'cover'
            }}
            className={'user-image'} />
        </div>
        <div className={'user-name'}>{account?.name}</div>
      </div>

      {menuMode === 'context' && (
        <ContextMenu
          items={menuItems}
          target={'.user-button'}
          showEvent={'dxclick'}
          width={210}
          cssClass={'user-menu'}
        >
          <Position my={{ x: 'center', y: 'top' }} at={{ x: 'center', y: 'bottom' }} />
        </ContextMenu>
      )}
      {menuMode === 'list' && (
        <List className={'dx-toolbar-menu-action'} items={menuItems} />
      )}
    </div>
  );
}


// const CustomLabel: React.FC = () => (
//   <div style={{ fontWeight: "bold", color: "#888", padding: "4px 10px" }}>
//     Azioni disponibili
//   </div>
// );
